<ape-drawer
  [visible]="visible"
  [title]="TRANSLATION_KEYS.admin.calibrationTalentMatrix.hrComment.TITLE"
  [position]="'right'"
  [closable]="true"
  [dismissible]="true"
  (closeClick)="onCloseRequested()"
  (visibleChange)="!$event && onCloseRequested()"
>
  <div
    *ngIf="visible"
    class="flex flex-col gap-5"
  >
    <p
      *ngIf="userFullName"
      class="text-gray-black text-base leading-7"
    >{{ userFullName }}</p>
    <ape-calibration-hr-comment
      [processId]="processId"
      [userId]="userId"
      (saved)="saved.emit($event)"
    />
  </div>
</ape-drawer>
